import React, { useState } from "react";
import { Box, Typography, Stack, TextField } from "@mui/material";
import AccountCheckbox from "../../filters-panel/account-checkbox.jsx";
import CoverPageModal from "../cover-page-modal.jsx";

const FetchNewData = ({
  useFreshAnalytics,
  setUseFreshAnalytics,
  coverPageText,
  setCoverPageText,
  reportId,
}) => {
  const [showFetchNewData, setShowFetchNewData] = useState(false);
  const [coverPageModal, setCoverPageModal] = useState(false);

  return (
    <Box>
      <Typography
        className="label"
        component="div"
        sx={{ cursor: "pointer" }}
        onClick={() => setShowFetchNewData(!showFetchNewData)}
      >
        Advanced Options
        <i
          class={`fa ${
            showFetchNewData ? "fa-chevron-down" : "fa-chevron-right"
          }`}
          aria-hidden="true"
        ></i>
      </Typography>

      {showFetchNewData && (
        <>
          <Stack
            direction="row"
            className="label-link"
            spacing="10px"
            alignItems="center"
            sx={{ marginBottom: "10px" }}
            onClick={() => setCoverPageModal(true)}
          >
            <i class="fa fa-pencil" aria-hidden="true"></i>
            <Typography component="span">Cover Page</Typography>
          </Stack>

          {!reportId && (
            <Box className="checkbox-tree">
              <AccountCheckbox
                label="Use Fresh Data"
                checked={useFreshAnalytics}
                onChange={() => setUseFreshAnalytics(!useFreshAnalytics)}
              />
              <Stack direction="row" spacing="6px" sx={{ marginTop: "5px" }}>
                <i
                  class="fa fa-exclamation-triangle error-icon"
                  aria-hidden="true"
                ></i>
                <Typography component="span" className="checkbox-tip">
                  This is very resource intensive and can result in your
                  Facebook or Twitter access being revoked if used too
                  frequently. Use no more than twice a month.
                </Typography>
              </Stack>
            </Box>
          )}
        </>
      )}

      <CoverPageModal
        open={coverPageModal}
        onClose={() => setCoverPageModal(false)}
        coverPageText={coverPageText}
        onSubmit={setCoverPageText}
      />
    </Box>
  );
};

export default FetchNewData;
